import React, { useCallback, useEffect, useState } from 'react';
import { IconAsChunk } from '@boschebike/ebds-react-icons';
import { secureWebComponents } from '../helpers/secureWebComponents.js';
import Button from './Button.js';
import classNames from '../helpers/classNames.js';
const RealIcon = ({
  icon,
  type
}) => {
  if (type === 'success') return /*#__PURE__*/React.createElement(IconAsChunk, {
    iconName: "Checkmark"
  });
  if (type === 'warning') return /*#__PURE__*/React.createElement(IconAsChunk, {
    iconName: "AlertWarning"
  });
  if (type === 'error') return /*#__PURE__*/React.createElement(IconAsChunk, {
    iconName: "AlertError"
  });
  return typeof icon === 'string' ? /*#__PURE__*/React.createElement(IconAsChunk, {
    iconName: icon
  }) : icon;
};
const Toast = secureWebComponents(({
  id,
  title,
  text,
  type = Toast.types.info,
  icon,
  primaryActionText,
  dismissActionText,
  onPrimary,
  onDismiss,
  onOpening,
  onOpened,
  onClosing,
  onClosed
}) => {
  const [open, setOpen] = useState(false);
  const [displayedId, setDisplayedId] = useState(0);
  const [enabled, setEnabled] = useState(false);
  const openToast = useCallback(() => {
    setOpen(true);
    if (onOpening) onOpening();
    setTimeout(() => {
      setEnabled(true);
      if (onOpened) onOpened();
    }, 300);
  }, [setOpen, setEnabled, onOpening, onOpened]);
  const closeToast = useCallback(() => {
    setOpen(false);
    setEnabled(false);
    if (onClosing) onClosing();
    setTimeout(() => {
      if (onClosed) onClosed();
    }, 300);
  }, [setOpen, setEnabled, onClosing, onClosed]);
  useEffect(() => {
    if (displayedId === id) return;
    if (id === 0) closeToast();else openToast();
    setDisplayedId(id);
  }, [id, displayedId, setDisplayedId, openToast, closeToast]);
  return /*#__PURE__*/React.createElement("div", {
    "aria-live": type === 'error' || type === 'warning' ? 'assertive' : 'polite',
    role: "alert",
    className: classNames('ebds-toast', {
      '--open': open,
      '--close': !open,
      [`--${type}`]: true
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "ebds-toast__container"
  }, icon || ['success', 'warning', 'error'].includes(type) ? /*#__PURE__*/React.createElement("div", {
    className: "ebds-toast__container__icon"
  }, /*#__PURE__*/React.createElement(RealIcon, {
    icon: icon,
    type: type
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "ebds-toast__container__text"
  }, title ? /*#__PURE__*/React.createElement("strong", null, title) : null, /*#__PURE__*/React.createElement("div", null, text)), /*#__PURE__*/React.createElement("div", {
    className: "ebds-toast__container__actions"
  }, onPrimary ? /*#__PURE__*/React.createElement(Button, {
    className: "ebds-toast__container__actions__primary",
    srText: primaryActionText ?? 'disabled',
    text: primaryActionText,
    state: enabled ? 'normal' : 'disabled',
    mode: "tertiary",
    onClick: onPrimary
  }) : null, /*#__PURE__*/React.createElement(Button, {
    className: "ebds-toast__container__actions__dismiss",
    text: dismissActionText,
    srText: dismissActionText ?? 'disabled',
    state: enabled ? 'normal' : 'disabled',
    mode: "tertiary",
    onClick: onDismiss
  }))));
});
Toast.types = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'error'
};
export default Toast;